module.exports = __webpack_public_path__ + "static/media/Gävle läkarmottagning uses telemedicine software for digital specialist care.eebefe03.webp";